
<footer class="footer bg-light">
    <div class="container text-center">
        <p>
            Diogo Bras {{ currentYear }} © All Rights Reserved
        </p>
    </div>
</footer>